<div [formGroup]="form">
  <ng-container *ngIf="question.requireAnswer; then required; else nonrequired">
  </ng-container>
  <ng-template #required>
    <mat-label [attr.for]="question.id">{{ question.description }} *</mat-label>
  </ng-template>
  <ng-template #nonrequired>
    <mat-label [attr.for]="question.id">{{ question.description }}</mat-label>
  </ng-template>
  <ng-container [ngSwitch]="question.questionCtrlTypeId">
    <mat-form-field class="form-field" appearance="standard">
      <select
        matNativeControl
        *ngSwitchCase="questionCtrlType.MULTIPLE_CHOICE"
        [id]="question.id"
        [formControlName]="question.id"
      >
        <option value="">Select an option</option>
        <option
          *ngFor="let opt of question.questionOptions"
          [value]="opt.description"
        >
          {{ opt.description }}</option
        >
      </select>
      <input
        *ngSwitchCase="questionCtrlType.FREE_TEXT"
        matInput
        [formControlName]="question.id"
        [id]="question.id"
        class=""
        placeholder=""
        maxlength="2048"
      />
      <input
        *ngSwitchCase="questionCtrlType.NUMBERIC_TEXT"
        matInput
        [formControlName]="question.id"
        [id]="question.id"
        class=""
        (keypress)="numberOnly($event)"
        placeholder="Number"
        maxlength="2048"
        inputmode="numeric"
        pattern="[0-9]+"
        numberOnly
      />
    </mat-form-field>
  </ng-container>
  <div *ngIf="submitted && f.errors">
    <div *ngIf="f.errors.required" class="color-danger">
      This field is required
    </div>
  </div>
  <br />
</div>
